import login from '@/views/login/login'
const loginRouter = [
  { path: '/', name: 'login', component: login, meta: { title: '登录' } },
]
export default loginRouter
